import React from 'react'
import { getHexColor, OneColorIconProps } from '../utils'

export const RadioButtonUncheckedIcon: React.FC<OneColorIconProps> = ({ className, color = 'white', size = 16 }) => {
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.99992 14.6666C7.0777 14.6666 6.21103 14.4915 5.39992 14.1413C4.58881 13.7915 3.88325 13.3166 3.28325 12.7166C2.68325 12.1166 2.20836 11.411 1.85859 10.5999C1.50836 9.78881 1.33325 8.92214 1.33325 7.99992C1.33325 7.0777 1.50836 6.21103 1.85859 5.39992C2.20836 4.58881 2.68325 3.88325 3.28325 3.28325C3.88325 2.68325 4.58881 2.20814 5.39992 1.85792C6.21103 1.50814 7.0777 1.33325 7.99992 1.33325C8.92214 1.33325 9.78881 1.50814 10.5999 1.85792C11.411 2.20814 12.1166 2.68325 12.7166 3.28325C13.3166 3.88325 13.7915 4.58881 14.1413 5.39992C14.4915 6.21103 14.6666 7.0777 14.6666 7.99992C14.6666 8.92214 14.4915 9.78881 14.1413 10.5999C13.7915 11.411 13.3166 12.1166 12.7166 12.7166C12.1166 13.3166 11.411 13.7915 10.5999 14.1413C9.78881 14.4915 8.92214 14.6666 7.99992 14.6666ZM7.99992 13.3333C9.48881 13.3333 10.7499 12.8166 11.7833 11.7833C12.8166 10.7499 13.3333 9.48881 13.3333 7.99992C13.3333 6.51103 12.8166 5.24992 11.7833 4.21659C10.7499 3.18325 9.48881 2.66659 7.99992 2.66659C6.51103 2.66659 5.24992 3.18325 4.21659 4.21659C3.18325 5.24992 2.66659 6.51103 2.66659 7.99992C2.66659 9.48881 3.18325 10.7499 4.21659 11.7833C5.24992 12.8166 6.51103 13.3333 7.99992 13.3333Z"
        fill={getHexColor(color)}
      />
    </svg>
  )
}
